export default __webpack_public_path__ + "assets/images/b04013b15ecfd33210486d205248256e.svg";